// #region Constants to save on local storage on input search
export const FT_DT = "FT_DT"; // FILTER DOCUMENTS
export const FT_TT = "FT_TT"; // FILTER TRANSACTIONS
export const FT_ABAT = "FT_ABAT"; // FILTER ADD BOOKED AMOUNT TABLE
export const FT_ABATT = "FT_ABATT"; // FILTER ADD BOOKED ACOUNTING TRANSACTIONS TABLE
export const FT_SCT = "FT_SCT"; // FILTER SUGGESTED CANDIDATES TABLE
export const FT_TNAR = "FT_TNAR"; // FILTER TNA RULES TABLE
export const FT_MTPAL = "FT_MTPAL"; // FILTER MY TEAM PRESENCE AND LEAVES OVERVIEWS TABLE
export const FT_TNAP = "FT_TNAP"; // FILTER TNA POLICIES TABLE
export const FT_BAC = "FT_BAC"; // FILTER BANK AND CASH TABLE
export const FT_ERT = "FT_ERT"; // FILTER EXPENSES REVENUE TYPES TABLE
export const FT_PNLC = "FT_PNLC"; // FILTER PNL CALCULATION TABLE
export const FT_PNLCF = "FT_PNLCF"; // FILTER PNL CONFIG TABLE
export const FT_PNLT = "FT_PNLT"; // FILTER PNL TYPES TABLE
export const FT_PAPA = "FT_PAPA"; // FILTER PROJECT ASSIGNMENTS PENDING APPROVALS TABLE
export const FT_CT = "FT_CT"; // FILTER CLARIFICATIONS
export const FT_PAT = "FT_PAT"; // FILTER PROVIDER ACCOUNTS
export const FT_CAT = "FT_CAT"; // FILTER COMPANY ACCOUNTS
export const FT_CLT = "FT_CLT"; // FILTER COMPANY LEGAL ENTITIES
export const FT_CLTO = "FT_CLTO"; // FILTER COMPANY LEGAL ENTITIES OFFICE
export const FT_UT = "FT_UT"; // FILTER USERS
export const FT_ATT = "FT_ATT"; // FILTER AUDIT TYPES
export const FT_CST = "FT_CST"; //  FILTER CLARIFICATION STATUSES
export const FT_CTT = "FT_CTT"; // FILTER CLARIFICATION Types
export const FT_CATT = "FT_CATT"; // FILTER COMPANY ACCOUNT TYPE
export const FT_COT = "FT_COT"; // FILTER COUNTRIES
export const FT_CG = "FT_CG"; // FILTER CONSOLIDATION GROUPS
export const FT_SKL = "FT_SKL"; // FILTER SKILLS TABLE
export const FT_APTT = "FT_APTT"; // FILTER ADMINISTRATIVE PROCESS TYPES TABLE
export const FT_CUT = "FT_CUT"; // FILTER CURRENCIES
export const FT_DCT = "FT_DCT"; // FILTER DOCUMENT CATEGORIES
export const FT_DOT = "FT_DOT"; // FILTER DOCUMENT TYPES
export const FT_DTS = "FT_DTS"; // FILTER DOCUMENT TYPES schedules
export const FT_LT = "FT_LT"; // FILTER LEGISLATION
export const FT_LAP = "FT_LAP"; // FILTER LEGISLATION ADMINISTRATIVE PROCESS TABLE
export const FT_TST = "FT_TST"; // FILTER TRANSACTION STATUSES
export const FT_TTT = "FT_TTT"; // FILTER TRANSACTION TYPES
export const FT_SAA = "FT_SAA"; // FILTER SYSTEM ADMINISTRATION ACCESS
export const FT_SPA = "FT_SPA"; // FILTER SERVICE PROVIDERS ACCESS
export const FT_CAA = "FT_CAA"; // FILTER COMPANY ACCOUNT ACCESS
export const FT_LEA = "FT_LEA"; // FILTER LEGAL ENTITY ACCESS
export const FT_PS = "FT_PS"; // FILTER PROVIDER SITES
export const FT_PAW = "FT_PAW"; // FILTER PROVIDER ALLOWED WIDGETS
export const FT_AL = "FT_AL"; // FILTER AVAILABLE LANGUAGES
export const FT_EXCH = "FT_EXCH"; // FILTER LEGAL ENTITY exchange rates
export const FT_LECT = "FT_LECT"; // FILTER LEGAL ENTITY CLIENTS TABLE
export const FT_LEPA = "FT_LEPA"; // FILTER PROJECT ASSIGNMENTS TABLE
export const FT_EAMT = "FT_EAMT"; // FILTER EMPLOYEE ADDRESS MUTATIONS TABLE
export const FT_EBAM = "FT_EBAM"; // FILTER EMPLOYEE BANK ACCOUNT MUTATIONS TABLE
export const FT_EDMT = "FT_EDMT"; // FILTER EMPLOYEE DEPENDENT MUTATIONS TABLE
export const FT_EED = "FT_EED"; // FILTER EMPLOYEE DOCUMENTS  TABLE
export const FT_EEMT = "FT_EEMT"; // FILTER EMPLOYEE MUTATIONS TABLE
export const FT_EEVTS = "FT_EEVTS"; // FILTER EMPLOYEE VIEW TABLES
export const FT_EEOVTS = "FT_EEOVTS"; // FILTER EMPLOYEES OVERVIEW TABLES
export const FT_ETVTS = "FT_ETVTS"; // FILTER EMPLOYEE TEMPORAL VALUES TABLES
export const FT_LEBA = "FT_LEBA"; // FILTER LEGAL ENTITY BANK ACCOUNTS TABLE
export const FT_LECST = "FT_LECST"; // FILTER LEGAL ENTITY CASH STATEMENTS TABLE
export const FT_LECPT = "FT_LECPT"; // FILTER LEGAL CLOSED PERIODS TABLE
export const FT_LEC = "FT_LEC"; // FILTER LEGAL ENTITY CONTRACTS TABLE
export const FT_LEVT = "FT_LEVT"; // FILTER LEGAL ENTITY VENDORS TABLE
export const FT_LECIT = "FT_LECIT"; // FILTER LEGAL ENTITY CLIENT INVOICES TABLE
export const FT_LEVIT = "FT_LEVIT"; // FILTER LEGAL ENTITY VENDOR INVOICES TABLE
export const FT_LEP = "FT_LEP"; // FILTER LEGAL ENTITY PROJECTS TABLE
export const FT_AS = "FT_LEA"; // FILTER LEGAL ENTITY ASSETS
export const FT_LEL = "FT_LEL"; // FILTER LEGAL ENTITY LOANS
export const FT_LEDBT = "FT_LEDBT"; // FILTER LEGAL ENTITY DONATION BENEFICIARIES TABLE
export const FT_LEDMT = "FT_LEDMT"; // FILTER LEGAL ENTITY DONATORS MEMBERS TABLE
export const FT_LECPM = "FT_LECPM"; // FILTER LE CLOSED PERIOD MATRIX
export const FT_TDF = "FT_TDF"; // TRANSACTION DYNAMIC FIELD
export const FT_DFD = "FT_DFD"; // DYNAMIC FIELD DEFINITION
export const FT_FVT = "FT_FVT"; // FIELD VALUE TYPE
export const FT_CDR = "FT_CDR"; // FILTER COMPLIANCE DOCUMENTS REPORT
export const FT_DPR = "FT_DPR"; // FILTER DOCUMENTS PAYROLL REPORT
export const FT_IVTR = "FT_IVTR"; // FILTER COMPLIANCE DOCUMENTS REPORT
export const FT_AST = "FT_AST"; // FILTER ASSET TYPES
export const FT_ETT = "FT_ETT"; // FILTER EVENT TYPES TABLE
export const FT_AEST = "FT_AEST"; // FILTER ACCOUNTING ENTRY STATUSES TABLE
export const FT_AETT = "FT_AETT"; // FILTER ACCOUNTING ENTRY TYPES TABLE
export const FT_PEST = "FT_PEST"; // FILTER PAYROLL ENTRY STATUSES TABLE
export const FT_PETT = "FT_PETT"; // FILTER PAYROLL ENTRY TYPES TABLE
export const FT_MEA = "FT_MEA"; // FILTER MANAGE EMPLOYEES ACCESS
export const FT_ULR = "FT_ULR"; // FILTER USER LOGIN RESTRICTIONS
export const FT_CUEDA = "FT_CUEDA"; // FILTER CURRENT USER EMPLOYMENT DATA ACCESS
export const FT_FSL = "FT_FSL"; // FILTER FILE STORAGE LOCATIONS
export const FT_WID = "FT_WID"; // FILTER WIDGETS
export const FT_EDT = "FT_EDT"; // FILTER EMPLOYEE DEPENDENT TYPES
export const FT_TAL = "FT_TAL"; // FILTER Time and attendance LEGISLATION LEVEL
export const FT_TAC = "FT_TAC"; // FILTER Time and attendance COMPANY ACCOUNT LEVEL
export const FT_TALE = "FT_TALE"; // FILTER Time and attendance LEGAL ENTITY LEVEL
export const FT_H2RT = "FT_H2RT"; // FILTER TNA HOW 2 REPORT TIMES
export const FT_SCH = "FT_SCH"; // FILTER TNA SCHEDULES
export const FT_CAL = "FT_CAL"; // FILTER TNA CALENDARS (PUBLIC HOLIDAYS)
export const FT_VDAA = "FT_VDAA"; // FILTER TNA VACATION DAYS ADDED AT
export const FT_AACC = "FT_AACC"; // FILTER ASSEMBLIES, AUDITS, CORPORATE CHANGES
export const FT_RDIP = "FT_RDIP"; // FILTER REGISTRATIONS, DOCUMENTS, IDs, POAs
export const FT_LESI = "FT_LESI"; // FILTER LEGAL ENTITY SECRET INFORMATION
export const FT_PI = "FT_PI"; // FILTER PAYROLL INPUT
export const FT_AI = "FT_AI"; // FILTER ACCOUNTING INPUTS
export const FT_PR = "FT_PR"; // FILTER PAYROLL RUNS
export const FT_PT = "FT_PT"; // FILTER POSITIONS TABLE
export const FT_CDT = "FT_CDT"; // FILTER CANDIDATES TABLE
export const FT_HRT = "FT_HRT"; // FILTER HIRING CLIENTS TABLE
export const FT_IT = "FT_IT"; // FILTER INTERVIEWS TABLE
export const FT_RT = "FT_RT"; // FILTER RECRUITERS TABLE
export const FT_RMAT = "FT_RMAT"; // FILTER RECRUITING MODULE ACCESS TABLE
export const FT_UAH = "FT_UAH"; // FILTER USER ACTIVITY HISTORY
export const FT_MPOL = "FT_MPOL"; //FILTER POLICIES MANAGMENT
export const FT_VPOL = "FT_VPOL"; //FILTER VIEW POLICIES
export const FT_UASD = "FT_UASD"; //FILTER USER ACTIVITY SHARED DOCUMENTS
export const FT_PNLF = "FT_PNLF"; //FILTER PnL FORECAST
export const FT_PNLR = "FT_PNLR"; //FILTER PnL REPORT
export const FT_PNLRT = "FT_PNLRT"; //FILTER PnL REPORT TRANSACTIONS
export const FT_PNLRF = "FT_PNLRF"; //FILTER PnL REPORT FORECASTS
export const FT_TET = "FT_TET"; //FILTER TRAVEL EXPENSE TYPES
export const FT_MER = "FT_MER"; //FILTER MANAGER EXPENSE REPORTS
export const FT_MERH = "FT_MERH"; //FILTER MANAGER EXPENSE REPORT HISTORY
export const FT_MSA = "FT_MSA"; //FILTER MANAGER SPEND ANALYSIS
export const FT_EER = "FT_EER"; //FILTER EMPLOYEE EXPENSE REPORTS
export const FT_EERH = "FT_EERH"; //FILTER EMPLOYEE EXPENSE REPORT HISTORY
export const FT_ESA = "FT_ESA"; //FILTER EMPLOYEE SPEND ANALYSIS
export const FT_WT = "FT_WT"; //FILTER FOR WAGE TYPES
export const FT_WTM = "FT_WTM"; //FILTER FOR WAGE TYPE MAPPINGS
export const FT_GTNST = "FT_GTNST"; //FILTER FOR GTN SOURCE TYPE
export const FT_LEWTM = "FT_LEWTM"; //FILTER FOR LEGAL ENTITY WAGE TYPE MAPPING
export const FT_LEATCN = "FT_LEATCN"; //FILTER FOR LEGAL ENTITY ABSENCE TYPE CUSTOM NAME
export const FT_MLT = "FT_MLT"; //FILTER MY LEAVES TABLE
export const FT_TTD = "FT_TTD"; //FILTER TRANSACTION TO DELETE
export const FT_TON = "FT_TON"; //FILTER TNA OVERVIEW EMPLOYEE NOTIFICATIONS
export const FT_TOA = "FT_TOA"; //FILTER TNA OVERVIEW EMPLOYEE ACTIVITY
export const FT_TOAN = "FT_TOAN"; //FILTER TNA OVERVIEW EMPLOYEE ACTIVITY AND NOTIFICATIONS
export const FT_CSP = "FT_CSP"; //FILTER FOR CHECK SPLITTED PAYSLIPS
export const FT_LSSCR = "FT_LSSCR"; //FILTER FOR LEGISLATION SOCIAL SECURITY COST RATES
export const FT_LESC = "FT_LESC"; //FILTER FOR LEGISLATION EMPLOYEE COST SECTIONS
export const FT_LECSG = "FT_LECSG"; //FILTER FOR LEGISLATION EMPLOYEE COST SECTION GROUP
export const FT_PECR = "FT_PECR"; //FILTER FOR PROFORMA EMPLOYEE COST REPORT
export const FT_ECST = "FT_ECST"; //FILTER FOR EMPLOYEE COST SECTION TYPE
export const FT_PPI = "FT_PPI"; //FILTER FOR PROVIDE PAYROLL INPUT
export const FT_MTDT = "FT_MTDT"; //FILTER FOR MY TEAM DOCUMENTS TABLE
export const FT_ALU = "FT_ALU"; //FILTER FOR ALERT LINE URLS
export const FT_VC = "FT_VC"; //FILTER VIOLATION CLASSIFICATION
export const FT_ALRS = "FT_ALRS"; //FILTER ALERT LINE REPORT STATUS
export const FT_ALSN = "FT_ALSN"; //FILTER ALERT LINE SUGGESTED NOTE
export const FT_TESACT = "FT_TESACT"; //FILTER TRAVEL EXPENSE SUGGESTED AUDIT COMMENT TABLE
export const FT_TESN = "FT_TESN"; //FILTER TRAVEL EXPENSE SUGGESTED NOTE
export const FT_MTP = "FT_MTP"; //FILTER MY TEAM POLICIES
export const FT_MI = "FT_MI"; //FILTER MAIL INBOX TABLE
export const FT_MMIA = "FT_MMIA"; //FILTER MANAGE MAIL INBOX ADDRESSEE
export const FT_ESCIT = "FT_ESCIT"; //FILTER FOR EMPLOYEE SURVEY CONFIGURATION ITEM TYPE
export const FT_ESES = "FT_ESES"; //FILTER FOR EMPLOYEE SURVEY EXPLANATION SUGGESTIONS
export const FT_MPSAP = "FT_MPSAP"; //FILTER MANAGE PROVIDER SITE ADVERTISEMENT POPUPS
export const FT_DT_TEMPLATES = "FT_DT_TEMPLATES"; //FILTER DOCUMENT TEMPLATES
export const FT_TLC = "FT_TLC"; // FILTER LOCATION CODES
export const FT_LEATE = "FT_LEATE"; //FILTER LEGAL ENTITY ABSENCE TYPE EXCLUSION TABLE
// #endregion
